"use client"

import { ShieldHalf } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ShieldHalfIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ShieldHalfIcon = component(Icon)({ as: ShieldHalf })
